module.exports = __webpack_public_path__ + "img/right-arrow-color.47507db8.png";